var detailHeader;
var detailHeaderInner;
var detailImageWrapper;
var detailInfoWrapper;
var detailInfoHeadline;

function repositionDetail() {
  if ($(".type-detail").length) {
    detailHeader = $(".p-detail-inner");
    detailHeaderInner = $(".p-detail-inner-header");
    detailProductTop = $(".product-top");
    detailImageWrapper = $(".product-top > .p-image-wrapper");
    detailInfoWrapper = $(".product-top > .p-info-wrapper");

    // reposition detail info
    repositionDetailHeader();

    // reposition detail products
    repositionDetailProducts();

    repositionDetailParameterToNewTab();

    detailInfoWrapper.find(".detail-parameters th").text("Változatok:");

    detailInfoWrapper.find(".add-to-cart-button").text("A kosárba");

    $(".basic-description iframe").each(function () {
      $(this).wrap('<div class="iframe-responsive"></div>');
    });

    if (detailImageWrapper.find(".flag-freeshipping").length) {
      detailImageWrapper
        .find(".flag-freeshipping .flag-text")
        .text("Ingyenes szállítás");
      if (detailImageWrapper.find(".flags-default").length) {
        detailImageWrapper
          .find(".flags-default")
          .prepend(detailImageWrapper.find(".flag-freeshipping"));
      } else {
        detailImageWrapper
          .find(".p-image")
          .prepend('<div class="flags flags-default"></div>');
        detailImageWrapper
          .find(".flags-default")
          .prepend(detailImageWrapper.find(".flag-freeshipping"));
      }
    }
  }
}

function stringContainsNumber(string) {
  return /\d/.test(string);
}

function repositionDetailHeader() {
  // reposition flags default
  var flags = detailProductTop.find(".flags-default");
  $(".p-image").prepend(flags);

  // replace discount text
  if (detailImageWrapper.find(".price-save").length) {
    if (detailImageWrapper.find(".price-save .parameter-dependent").length) {
      detailImageWrapper
        .find(".price-save .parameter-dependent")
        .each(function () {
          var priceSave = $(this);
          var newPriceSave = priceSave.text().split("–")[1];
          var testNumber = stringContainsNumber(newPriceSave);
          if (testNumber) {
            var newPriceSaveExt = newPriceSave.replace(/\s/g, "").split("%")[0];
            priceSave.html("<span>-" + newPriceSaveExt + "<sub>%</sub></span>");
          }
        });
    } else if (detailImageWrapper.find(".price-save .choose-variant").length) {
      detailImageWrapper.find(".price-save .choose-variant").each(function () {
        var priceSave = $(this);
        var newPriceSave = priceSave.text().split("–")[1];
        var testNumber = stringContainsNumber(newPriceSave);
        if (priceSave.hasClass("default-variant")) {
          var priceSaveFrom = "až";
        } else {
          var priceSaveFrom = "";
        }
        if (testNumber) {
          var newPriceSaveExt = newPriceSave.replace(/\s/g, "").split("%")[0];
          priceSave.html(
            '<span class="price-save-from">' +
              priceSaveFrom +
              "</span><span>-" +
              newPriceSaveExt +
              "<sub>%</sub></span>"
          );
        }
      });
    } else {
      var priceSave = $(".p-image .price-save");
      var newPriceSave = priceSave
        .text()
        .split("–")[1]
        .replace(/\s/g, "")
        .split("%")[0];
      priceSave.html("<span>-" + newPriceSave + "<sub>%</sub></span>");
    }
  }

  if (
    detailImageWrapper.find(".flag-discount").length &&
    detailImageWrapper.find(".flag-discount .price-save").length == 0
  ) {
    detailImageWrapper.find(".flag-discount").remove();
  }

  // reposition thumbnails arrows
  if (detailImageWrapper.find(".p-thumbnails-wrapper .thumbnail-prev").length) {
    $(".p-thumbnails-wrapper").append(
      $(".p-thumbnails-wrapper .thumbnail-prev")
    );
    $(".p-thumbnails-wrapper").append(
      $(".p-thumbnails-wrapper .thumbnail-next")
    );

    $(".p-thumbnails-wrapper > a").wrapAll(
      '<div class="p-thumbnails-arrows"></div>'
    );
  }

  // reposition h1
  detailInfoWrapper.prepend('<div class="p-info-headline"></div>');
  detailInfoHeadline = $(".p-info-headline");
  var detailName = $(".p-detail-inner-header h1");
  var detailRating = $(".p-detail-info");
  var detailCode = $(".p-detail-inner-header .p-code");

  // reposition h1
  detailInfoHeadline.append(detailName);

  // reposition stars wrapper
  detailInfoHeadline.append(detailRating);

  // reposition products code
  detailInfoHeadline.find(".p-detail-info").append(detailCode);

  // reposition product label
  if ($(".p-detail-info > div:not(.stars-wrapper)").length) {
    var productLabel = $(".p-detail-info > div:not(.stars-wrapper)");
    var productCode = $(".p-detail-info .p-code");
    productLabel.prepend(productCode);
  }

  // Create clone of product headline
  var detailInfoHeadlineClone = $(".p-info-headline").clone();
  detailHeaderInner.append(detailInfoHeadlineClone);
  detailHeaderInner
    .find("h1")
    .replaceWith(
      $("<div class='h1'>" + detailHeaderInner.find("h1").text() + "</div>")
    );

  // reposition product perex
  detailInfoWrapper
    .find(".p-short-description, .p-short-description + p")
    .wrapAll('<div class="p-short-description-block"></div>');
  $(".p-short-description-block").insertAfter(detailInfoHeadline);

  if ($(".p-info-wrapper .detail-parameters").length) {
    $(".p-info-wrapper .detail-parameters").insertBefore(
      ".p-info-wrapper .p-final-price-wrapper"
    );
  }

  if ($(".p-info-wrapper .availability-value").length) {
    $(".p-info-wrapper .availability-value").insertBefore(
      ".p-info-wrapper .p-final-price-wrapper"
    );
  }
}

function repositionDetailProducts() {
  // reposition products related
  if ($(".products-related-header").length) {
    $(
      ".products-related-header, .products-related, .products-related  + .browse-p"
    ).wrapAll('<div class="products-related-block"></div>');
    if ($(".products-related-block .p-detail-tabs-wrapper").length) {
      $(".p-detail").append($(".products-related-block"));
      $(".p-detail-tabs-wrapper").insertBefore(".products-related-block");
    } else {
      $(".products-related-block").insertAfter(".p-detail-tabs-wrapper");
    }
    productsRelated = $(".products-related .product");
  }

  if ($(".products-alternative").length) {
    productsAlternativeItems = $(".products-alternative .product");
  }

  // reposition products alternative
  if ($(".tab-pane#productsAlternative").length) {
    var productsAlternative = $(".tab-pane#productsAlternative");
    productsAlternative.wrapInner(
      '<div class="products-alternative-block"></div>'
    );
    if ($(".products-related-header").length) {
      $(".products-alternative-block").insertAfter(".products-related-block");
    } else {
      $(".products-alternative-block").insertAfter(".p-detail-tabs-wrapper");
    }
    $('.shp-tab-link[href="#productsAlternative"]')
      .closest(".shp-tab")
      .remove();

    $(".products-alternative-block").prepend(
      '<h2 class="products-alternative-header">Hasonló termékek</h2>'
    );
  }

  if (
    $(".products-related-header").length ||
    $(".products-alternative-block").length
  ) {
    // create slider from products
    createSliderFromProductsDetail();
  }
}

function createSliderFromProductsDetail() {
  $(".products-block").each(function () {
    var productsItems = $(this);

    var productsSlide = productsItems.find(".product");

    productsSlide.wrap('<div class="swiper-slide"></div>');

    productsItems.wrapInner(
      '<div class="swiper-container js-slider-products-detail"></div>'
    );

    productsItems
      .find(".swiper-container")
      .wrapInner('<div class="swiper-wrapper"></div>');

    productsItems.wrapInner(
      '<div class="js-slider-group slider-group-products"></div>'
    );

    var paginationTemplate =
      '<div class="swiper-pagination js-swiper-pagination"></div>';

    productsItems.find(".slider-group-products").append(paginationTemplate);

    var arrowTemplate =
      '<div class="swiper-arrow swiper-arrow-next js-swiper-arrow-next">' +
      '<div class="swiper-arrow-content">' +
      "<span></span>" +
      "</div>" +
      "</div>" +
      '<div class="swiper-arrow swiper-arrow-prev js-swiper-arrow-prev">' +
      '<div class="swiper-arrow-content">' +
      "<span></span>" +
      "</div>" +
      "</div>";
    productsItems.find(".slider-group-products").append(arrowTemplate);

    productsDetailImagesSlider();
  });
}

function productsDetailImagesSlider() {
  if ($(".js-slider-products-detail").length) {
    $(".js-slider-products-detail").each(function () {
      var inst = $(this),
        swiperBlock = inst.closest(".js-slider-group"),
        swiperPagination = swiperBlock.find(".js-swiper-pagination"),
        swiperArrowPrev = swiperBlock.find(".js-swiper-arrow-prev"),
        swiperArrowNext = swiperBlock.find(".js-swiper-arrow-next");

      var productsBreakpoints = {
        200: {
          slidesPerView: 2,
        },
        480: {
          slidesPerView: 2,
          // slidesPerGroup: 1,
        },
        771: {
          slidesPerView: 3,
          // slidesPerGroup: 1,
        },
        992: {
          slidesPerView: 3,
          // slidesPerGroup: 1,
        },
        1200: {
          slidesPerView: 4,
          // slidesPerGroup: 1,
        },
        1440: {
          slidesPerView: 4,
          // slidesPerGroup: 1,
        },
      };

      var mySwiper = new Swiper(inst, {
        spaceBetween: 0,
        lazy: true,
        loop: true,
        speed: 600,
        pagination: {
          el: swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: swiperArrowNext,
          prevEl: swiperArrowPrev,
        },
        breakpoints: productsBreakpoints,
      });
    });
  }
}

function repositionDetailParameterToNewTab() {
  if ($("#description .extended-description").length) {
    var detailParameterContent = $("#description .extended-description");
    var detailParameterTab = `
			<li class="shp-tab" data-width="226">
				<a href="#productParameter" class="shp-tab-link" role="tab" data-toggle="tab">Paraméterek</a>
			</li>`;
    var detailParameterTabContent = `
			<div id="productParameter" class="tab-pane fade" role="tabpanel">
					<div class="description-inner description-inner--full">
					</div>
			</div>`;

    // $(detailParameterTab).insertAfter('#p-detail-tabs li:first-child');
    // $(detailParameterTabContent).insertAfter($('#tab-content .tab-pane[id="description"]'));
    $(detailParameterTab).insertAfter(
      $('#p-detail-tabs li a[href="#description"]').closest("li")
    );
    $(detailParameterTabContent).insertAfter(
      "#tab-content .tab-pane#description"
    );
    $("#tab-content #productParameter .description-inner").append(
      detailParameterContent
    );
    $("#description .extended-description").remove();
    // $(".shp-tab.active").removeClass("active");
    // $(".shp-tab:first-child").addClass("active");

    $('.shp-tab-link[href="#productParameter"]').click(function () {
      $(".tab-pane.active").removeClass("active");
      $(".tab-pane#productParameter").addClass("active in");
    });
  }
}
